import {
    AlternateEmail,
    AssignmentInd,
    Close,
    ContactPage,
    Description,
    Flag,
    Forum,
    UploadFile,
    Warning,
} from "@mui/icons-material";
import {
    Alert,
    Autocomplete,
    Backdrop,
    Box,
    Button,
    Chip,
    CircularProgress,
    Collapse,
    Grid,
    List,
    ListItem,
    MenuItem,
    Paper,
    Select,
    Snackbar,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { uploadFile } from "../api/api";

const Resumenes = () => {

    const textInitialState = {
        value: '',
        error: false
    }

    const selectInitialState = {
        value: '-1',
        error: false
    }

    const requiredInitialState = [
        "authors",
        "email",
        "file",
        "table",
    ]

    // Hooks

    const [missingRequiredFields, setMissingRequiredFields] = useState(requiredInitialState);

    const [authors, setAuthors] = useState(textInitialState);
    const [id, setID] = useState(textInitialState);
    const [email, setEmail] = useState(textInitialState);
    const [emailAlt, setEmailAlt] = useState("");
    const [table, setTable] = useState(selectInitialState);
    const [file, setFile] = useState({ name: "", file: "", error: false });
    const [messages, setMessages] = useState({ status: 0, message: "" });
    const [processing, setProcessing] = useState(false);

    // Functions  

    const changeField = (field, value, defaultValue, method) => {
        const error = value === defaultValue;

        if (!error) {
            setMissingRequiredFields((prev) => prev.filter((x) => x !== field));
        } else {
            if (!missingRequiredFields.includes(field))
                setMissingRequiredFields((prev) => [...prev, field]);
        }

        method({ value: value, error: error });
    };

    const changeFile = (event) => {
        const file = event.target.files[0];
        const error = file === undefined;

        if (!error) {
            setMissingRequiredFields((prev) => prev.filter((x) => x !== "file"));
        } else {
            if (!missingRequiredFields.includes("file"))
                setMissingRequiredFields((prev) => [...prev, "file"]);
        }

        setFile({ name: file.name, file, error: error });
    };

    const clearFields = () => {
        const fileUpload = document.getElementById("fu_file");

        setAuthors(textInitialState);
        setID(textInitialState);
        setEmail(textInitialState);
        setEmailAlt("");
        setTable(selectInitialState);

        if (fileUpload !== null) fileUpload.value = "";
        setFile({ name: "", file: "", error: false });

        setMissingRequiredFields(requiredInitialState);
    };

    const saveForm = async () => {
        let response = { status: 0, message: "" };

        const jsonData = JSON.stringify({
            user_authors: authors.value,
            user_id: id.value,
            user_email: email.value,
            user_alt_email: emailAlt,
            user_table: table.value,
        });

        setProcessing(true);

        // Create user record in realtime DB
        response = await uploadFile(file, jsonData);

        if (response.status === 200) {
            clearFields();
        }

        setProcessing(false);
        setMessages({ status: response.status, message: response.message });
    };

    const handleClose = () => {
        setMessages({ status: 0, message: "" });
    };

    return (
        <>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={messages.message !== ""}
                onClose={handleClose}
            >
                <Alert
                    variant="filled"
                    severity={messages.status === 0 ? "" : messages.status === 200 ? "success" : "error"}
                >
                    {messages.message}
                </Alert>
            </Snackbar>
            <Backdrop in={processing} sx={{ zIndex: 1300 }}>
                <Stack flexDirection='column' alignItems='center'>
                    <CircularProgress sx={{ color: 'rgb(18,161,154)' }} />
                    <Typography variant='subtitle1' sx={{ color: 'white' }}>
                        Procesando
                    </Typography>
                </Stack>
            </Backdrop>
            <Paper elevation={3}>
                <Box display="flex" flexDirection="column">
                    <Box p={1} sx={{ background: '#9CCC60', color: 'white' }}>
                        <Typography variant="h4" className="title poppins">
                            ENVÍO DE RESÚMENES
                        </Typography>
                    </Box>
                    <Grid
                        container
                        flexDirection="column"
                    >
                        <Grid item>
                            <Box display="flex" p={2}>
                                <Grid
                                    id="personal"
                                    container
                                    flexDirection="row"
                                    spacing={3}
                                    justifyContent='center'
                                >
                                    <Grid item>
                                        <Grid container alignItems="center" spacing={0.5}>
                                            <Grid item>
                                                <Description fontSize="small" />
                                            </Grid>
                                            <Grid item>
                                                <p>
                                                    Puede descargar la plantilla de resúmenes para el congreso en este
                                                </p>
                                            </Grid>
                                            <Grid item>
                                                <a href="/documentos/Plantilla para envío de resumen.docx" target="_blank" rel="noopener noreferrer" download>enlace.</a>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Grid container flexDirection="column" justifyContent='center' spacing={5}>
                                            <Grid item>
                                                <Box display="flex" justifyContent='center' alignItems="center">
                                                    <ContactPage fontSize="small" />
                                                    <TextField
                                                        id="txt_authors"
                                                        variant="outlined"
                                                        label="Autor/Autores"
                                                        placeholder="Ejemplo: Autor 1, Autor 2, Autor 3"
                                                        sx={{ marginLeft: "8px" }}
                                                        value={authors.value}
                                                        error={authors.error}
                                                        className='field'
                                                        onChange={(event) => changeField("authors", event.target.value, "", setAuthors)}
                                                        onBlur={() => {
                                                            setAuthors({ value: authors.value, error: authors.value === "" });
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item>
                                                <Box display="flex" justifyContent='center' alignItems="center">
                                                    <AssignmentInd fontSize="small" />
                                                    <TextField
                                                        id="txt_id"
                                                        variant="outlined"
                                                        label="Número de identificación o pasaporte"
                                                        sx={{ marginLeft: "8px" }}
                                                        className="field"
                                                        value={id.value}
                                                        error={id.error}
                                                        onChange={(event) => changeField("id", event.target.value, "", setID)}
                                                        onBlur={() => {
                                                            setID({ value: id.value, error: id.value === "" });
                                                        }}
                                                        required
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item>
                                                <Box display="flex" justifyContent='center' alignItems="center">
                                                    <AlternateEmail fontSize="small" />
                                                    <TextField
                                                        id="txt_email"
                                                        variant="outlined"
                                                        label="Correo Electronico"
                                                        sx={{ marginLeft: "8px" }}
                                                        className="field"
                                                        value={email.value}
                                                        error={email.error}
                                                        onChange={(event) => changeField("email", event.target.value, "", setEmail)}
                                                        onBlur={() => {
                                                            setEmail({ value: email.value, error: email.value === '' });
                                                        }}
                                                        required
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item>
                                                <Box display="flex" justifyContent='center' alignItems="center">
                                                    <AlternateEmail fontSize="small" />
                                                    <TextField
                                                        id="txt_alt_email"
                                                        variant="outlined"
                                                        label="Correo Electronico Secundario"
                                                        sx={{ marginLeft: "8px" }}
                                                        className="field"
                                                        value={emailAlt}
                                                        onChange={(event) => setEmailAlt(event.target.value)}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item>
                                                <Box display="flex" justifyContent='center' alignItems="center">
                                                    <Forum fontSize="small" />
                                                    <Select
                                                        id="ddl_mesa"
                                                        displayEmpty
                                                        sx={{ marginLeft: "8px", minWidth: "232px" }}
                                                        className="field"
                                                        value={table.value}
                                                        error={table.error}
                                                        onChange={(event) => changeField("table", event.target.value, "-1", setTable)}
                                                        onBlur={() => {
                                                            setTable({ value: table.value, error: table.value === '-1' });
                                                        }}
                                                    >
                                                        <MenuItem value="-1">
                                                            Seleccione su mesa
                                                        </MenuItem>
                                                        <MenuItem value="1.Paisaje Cultural y economía urbana">
                                                            1.Paisaje Cultural y economía urbana
                                                        </MenuItem>
                                                        <MenuItem value="2.Intervención arquitectónica: puesta en valor y relación con el contexto">
                                                            2.Intervención arquitectónica: puesta en valor y relación con el contexto
                                                        </MenuItem>
                                                        <MenuItem value="3.Sitios arqueológicos">3.Sitios arqueológicos</MenuItem>
                                                        <MenuItem value="4.Nuevas tecnologías en la gestión e intervención del patrimonio">4.Nuevas tecnologías en la gestión e intervención del patrimonio</MenuItem>
                                                        <MenuItem value="5.Difusión histórica y educación en el patrimonio">5.Difusión histórica y educación en el patrimonio</MenuItem>
                                                        <MenuItem value="6.Patrimonio artístico">6.Patrimonio artístico</MenuItem>
                                                    </Select>
                                                </Box>
                                            </Grid>
                                            <Grid item>
                                                <Box display="flex" justifyContent='center' alignItems="center">
                                                    <UploadFile fontSize="small" />
                                                    <input
                                                        id="fu_file"
                                                        type="file"
                                                        file
                                                        onChange={changeFile}
                                                        style={{ marginLeft: "8px" }}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                        <Grid id="footer" container justifyContent='center' item>
                            <Grid item>
                                <Box display="flex" p={1}>
                                    <Button
                                        sx={{ background: "rgb(18,161,154)" }}
                                        variant="contained"
                                        onClick={clearFields}
                                    >
                                        Limpiar Formulario
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box display="flex" p={1}>
                                    <Button
                                        disabled={missingRequiredFields.length > 0}
                                        sx={{ background: "rgb(18,161,154)" }}
                                        variant="contained"
                                        onClick={saveForm}
                                    >
                                        Confirmar Envío de Resúmen
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </>
    );
};

export default Resumenes;
